<template>
    <div class="columns is-multiline is-centered">
        <div
            v-for="(color, index) in colors"
            :key="index"
            class="column is-4 pb-1"
        >
            <div
                :style="`${getGradient(color)}`"
                class="gradient-box"
                @click="
                    selectedColor = color;
                    $emit('input', { type: 'gradient', value: color });
                "
            >
                <div v-if="selectedColor == color" class="is-overlay">
                    <div class="lb-selected-background is-overlay" />
                    <p
                        class="has-text-centered has-text-grass-green is-overlay lb-selected-check"
                    >
                        <span class="icon is-large">
                            <i
                                class="mdi mdi-48px mdi-checkbox-marked-circle"
                            ></i>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { colors } from '@/style/coolhue';
import { gradientBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    model: { prop: 'background' },
    props: {
        background: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            selectedColor: undefined,
            colors: this.sampleColors(6),
        };
    },
    computed: {
        getGradient() {
            return (colorData) => {
                return gradientBackground(colorData);
            };
        },
    },
    methods: {
        sampleColors(number) {
            // console.log('sampleColors');
            return _.sample(colors, number);
        },
    },
};
</script>

<style scoped>
.gradient-box {
    height: 6rem;
    position: relative;
}
</style>
